<HiddenFromSSR>
  <footer>
    {@html "<p> Semaphore is <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/NickColley/semaphore\">open-source software</a> maintained by <a rel=\"noopener\" target=\"_blank\" href=\"https://nickcolley.co.uk\">Nick Colley</a> and distributed under the <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/NickColley/semaphore/blob/main/LICENSE\">AGPL License</a>. It is a continuation of the Pinafore project created by <a rel=\"noopener\" target=\"_blank\" href=\"https://nolanlawson.com\">Nolan Lawson</a>. This is the \"Chost\" patch by <a href=\"https://blackle-mori.com/\">Blackle Mori</a>. </p>"}
  </footer>
</HiddenFromSSR>
<script>
  import HiddenFromSSR from './HiddenFromSSR.html'

  export default {
    components: {
      HiddenFromSSR
    }
  }
</script>
